// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { jsonObjectGuard } from './../foundations/index.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    applicationId: z.string().min(1).max(21),
    payload: jsonObjectGuard,
    changedFromPrevious: z.boolean().optional(),
    error: z.string().nullable().optional(),
    fetchedAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    applicationId: z.string().min(1).max(21),
    payload: jsonObjectGuard,
    changedFromPrevious: z.boolean(),
    error: z.string().nullable(),
    fetchedAt: z.number(),
});
export const PermissionAuditSnapshots = Object.freeze({
    table: 'permission_audit_snapshots',
    tableSingular: 'permission_audit_snapshot',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        applicationId: 'application_id',
        payload: 'payload',
        changedFromPrevious: 'changed_from_previous',
        error: 'error',
        fetchedAt: 'fetched_at',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'applicationId',
        'payload',
        'changedFromPrevious',
        'error',
        'fetchedAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
